import React from 'react';
import styled from 'styled-components/macro';

// import Receive from './Staking/Receive';
// import QRCodeSidebar from './Staking/QRCodeSidebar';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 45px;

  height: 100%;
`;

// const Sidebar = styled.div`
//   padding-left: 45px;
//   height: 100%;
//
//   border-left: 1px solid ${props => props.theme.bg4};
// `;

export function LiquidityTab() {
  return (
    <Layout>
      {/* <Receive />
      <Sidebar>
        <QRCodeSidebar />
      </Sidebar> */}
    </Layout>
  );
}
